import BodyModalWithActions from '../../../../components/common/modals/bodyModalWithActions'
import UpdateDateInscription from './UpdateDateInscription'
import {FormationOtherDatesType} from '../../../../types/api/formations'
import ContainedButton from '../../../../components/common/buttons/containedButton'
import SimpleButton from '../../../../components/common/buttons/simpleButton'
import { useState } from 'react'

interface Props {
  status: string
  dataDates : FormationOtherDatesType[] | undefined
  handleClose: () => void,
  oldTrainingId : string
  isRefreshed: () => void
  isRefreshedData : ()=> void
  onSuccess?: () => void
}
const BodyModalUpdateDates = ({ dataDates, handleClose, status, oldTrainingId, isRefreshed, isRefreshedData, onSuccess }: Props) => {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [submitForm, setSubmitForm] = useState<(() => void) | null>(null)
  
  const handleFormReady = (submitFn: () => void) => {
    setSubmitForm(() => submitFn)
  }
  
  return (
    <BodyModalWithActions
      content={<UpdateDateInscription 
        dataDates={dataDates} 
        cancelFn={handleClose} 
        status={status} 
        oldTrainingId={oldTrainingId}
        isRefreshed={isRefreshed}
        isRefreshedData={isRefreshedData}
        onSubmittingChange={setIsSubmitting}
        onFormReady={handleFormReady}
        onSuccess={onSuccess}
       />}
      actions={
        <>
          <SimpleButton handleClick={handleClose} />
          <ContainedButton
            title='Enregistrer'
            disabled={isSubmitting}
            handleClick={() => {
              submitForm?.()
            }}
          />
        </>
      }
    />
  )
}

export default BodyModalUpdateDates
